import { useState, useEffect, useCallback } from 'react'
import { get } from '../lib/api'
import type { Talent } from '../types/api'

export function useTalents() {
  const [talents, setTalents] = useState<Talent[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const load = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const data = await get<Talent[]>('/api/v1/talents')
      setTalents(data)
    } catch (e) {
      setError(e instanceof Error ? e.message : '알 수 없는 오류')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    load()
  }, [load])

  return { talents, loading, error, reload: load }
}
